import SignOffs from 'components/sign-offs'
import SignRequests from 'components/sign-requests'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    template: 'chameleon'
  },
  [
    {
      path: '/signoffs',
      component: SignOffs.Index,
      name: 'signoffs.index',
    },
    {
      path: '/signoffs/:signoff_id',
      component: SignOffs.Show,
      name: 'signoffs.show',
      children: [
        {
          path: 'overview',
          component: SignOffs.Overview,
            name: 'signoffs.overview',
        },
        {
          path: 'document-signing/:sign_request_id',
          component: SignRequests.DocumentSigning,
            name: 'signoffs.document-signing',
        }
      ]
    },
  ])
